import router from '../router'
import store from '../store'
import bus from "./bus.js"
import { refreshToken } from "./api.js"
import { getExpire, getTokenInfo } from '../utils/auth'
const expiresCalculation = () => {
  const expires = getExpire() || 0
  const nDate = new Date()
  const nTime = nDate.getTime()
  const nTimeSecond = Math.floor(nTime / 1000)
  const expTime = expires - nTimeSecond
  // console.log(expTime)

  return new Promise(async (resolve, reject) => {
    //令牌时间超过到期前3分钟就更新令牌
    if (expTime > 180) {
      resolve()
    } else if (expTime > 1) {
      const tokenInfo = getTokenInfo()
      const param = {
        query: {
          action: 'RefreshToken'
        },
        body: {
          refresh_token: tokenInfo.refresh_token
        }
      }
      await refreshToken(param).then((res) => {
        if (res) {
          var cont = { ...res.data }
          cont['expire_time'] = 3600
          store.dispatch('user/setNewTokenInfo', cont)
        }
      })
      resolve()
    } else {
      store.dispatch('user/logout')
      bus.$message.warning('登录状态已失效，请重新登录！');
      router.push('/login')
      // reject()
    }
  })
}

export default expiresCalculation


// WEBPACK FOOTER //
// ./src/modules/web/api/expires.js